/* eslint-disable no-alert */
import { Builder } from '@builder.io/react';

import HeroDefaultWithImage from './hero-default-with-image';


Builder.registerComponent(HeroDefaultWithImage, {
  name: "HeroDefaultWithImage",
  inputs: [
    {
      name: "bgAnimated",
      type: "boolean",
      defaultValue: true
    },
    {
      name: 'icon',
      type: 'object',
      subFields: [
        {
          name: 'src',
          type: 'file',
          allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg'],
        },
        {
          name: 'alt',
          type: 'string',
        },
        {
          name: 'width',
          type: 'number',
        },
        {
          name: 'height',
          type: 'number',
        },
      ]
    },
    {
      name: "overtitle",
      type: "string"
    },
    {
      name: "title",
      type: "string",
      defaultValue: "Title here",
      onChange: (options) => {
        if (options.get('title').length > 65) {
          options.set('title', options.get('title').slice(0, 65))
          alert('maximum character is 65, delete characters to continue')
        }
      },
      helperText: 'Maximum characters is 65'
    },
    {
      name: 'product',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: "product",
      type: "string",
      showIf: `options.get('product')`,
      onChange: (options) => {
        if (options.get('product').length > 10) {
          options.set('product', options.get('product').slice(0, 10))
          alert('maximum character is 10, delete characters to continue')
        }
      },
      helperText: 'Only to naming products. Maximum characters is 10'
    },
    {
      name: "subtitle",
      type: "richText",
      defaultValue: "Description or Subtitle here",
      onChange: (options) => {
        if (options.get('subtitle').length > 450) {
          options.set('subtitle', options.get('subtitle').slice(0, 450))
          alert('maximum character is 450, delete characters to continue')
        }
      },
      helperText: 'Maximum characters is 450'
    },
    {
      name: 'cta',
      type: 'object',
      subFields: [
        {
          name: 'buttons',
          type: 'list',
          subFields: [
            {
              name: 'text',
              type: 'string'
            },
            {
              name: 'href',
              type: 'url'
            },
            {
              name: 'variant',
              type: 'string',
              defaultValue: 'primary',
              enum: ['primary', 'secondary', 'inverted']
            }
          ],
          defaultValue: [
            {
              text: 'Get Started',
              href: '/sales',
              variant: 'primary'
            }
          ]
        },
        {
          name: 'hubspotFormBanner',
          type: 'boolean',
          defaultValue: false
        },
        {
          name: 'hubspotFormBanner',
          type: 'boolean',
          defaultValue: false
        },
        {
          name: 'hubspotFormBanner',
          type: 'object',
          showIf: `options.get('hubspotFormBanner')`,
          subFields: [
            {
              name: 'id',
              type: 'string'
            },
            {
              name: 'label',
              type: 'string'
            },
            {
              name: 'duplicateId',
              type: 'number'
            }
          ]
        },
        {
          name: 'hubspotModal',
          type: 'boolean',
          defaultValue: false
        },
        {
          name: 'hubspotModal',
          type: 'object',
          showIf: `options.get('hubspotModal')`,
          subFields: [
            {
              name: 'formId',
              type: 'string'
            },
            {
              name: 'sfdcCampaignId',
              type: 'string'
            },
            {
              name: 'label',
              type: 'string'
            }
          ]
        }
      ]
    },
    {
      name: 'image',
      type: 'object',
      subFields: [
        {
          name: 'src',
          type: 'file',
          allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg'],
          defaultValue: 'https://cdn.builder.io/api/v1/image/assets%2Fe0438815ba51486bbb6a202747122d4b%2F9245b80daf6e46258858cabd5994367f',
        },
        {
          name: 'alt',
          type: 'string',
        },
        {
          name: 'width',
          type: 'number',
          defaultValue: 1630
        },
        {
          name: 'height',
          type: 'number',
          defaultValue: 1336
        },
      ]
    }
  ]
});